<div class="modal-cover" [ngClass]="{'loading_state': isLoadingState}">
    <div class="modal-header">
        <h4 *ngIf="someKindOfOperationUpdate; else createOperationHeader">
            {{ (isEditMode ? "Update" : workingMode) | titlecase }} the operation
            {{
                (operation.task.externalId || operation.task.job.externalId)
                    ? "#"
                        + (operation.task.job.externalId ? operation.task.job.externalId : '???')
                        + '-'
                        + (operation.task.externalId ? operation.task.externalId : '???')
                    : "- -"
            }}
        </h4>
        <ng-template #createOperationHeader>
            <h4>{{ workingMode | titlecase }} an operation</h4>
        </ng-template>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="cancel()"
        ></button>
    </div>

    <div class="modal-body">
        <div class="container container-fluid">
            <app-info-group-body>
                <form [formGroup]="operationForm">
                    <div class="form-container flex">
                        <!-- General information section -->
                        <div class="general-information col-2">
                            <div class="main-content-header">
                                <h5>General information</h5>
                            </div>
                            <table>
                                <tr class="form-field">
                                    <td class="col-label customer">
                                        Customer
                                        <ng-template #loadingCustomers>
                                            <span>
                                                <i class="icon fa-solid fa-arrows-rotate loading"></i>
                                            </span>
                                        </ng-template>
                                        <span *ngIf="isLoaded(customers); else loadingCustomers"
                                              class="required">
                                            *
                                        </span>
                                        <span *ngIf="selectedCustomer?.externalId"
                                              class="customer_number small_text">
                                            {{'#' + selectedCustomer?.externalId }}
                                        </span>
                                    </td>
                                    <td class="col-value">
                                        <div class="input-group">
                                            <span *ngIf="!canChangeCustomer">{{selectedCustomer?.name}}</span>
                                            
                                            <input *ngIf="canChangeCustomer"
                                                   id="customer"
                                                   #customerSearch
                                                   formControlName="customer"
                                                   class="form-control"
                                                   [ngbTypeahead]="searchCustomer"
                                                   #customerTypeahead="ngbTypeahead"
                                                   (keydown)="arrowKeyCheck($event, customerTypeahead)"
                                                   [resultFormatter]="
                                                    customerAheadFormatter
                                                "
                                                   [inputFormatter]="
                                                    customerValueFormatter
                                                "
                                                   [editable]="false"
                                                   container=".modal-open .modal"
                                                   (selectItem)="onCustomerSelect($event)"
                                                   [disabled]="!isLoaded(customers)"
                                                   (focus)="checkSelectedCustomer($event, true)"
                                                   (blur)="checkSelectedCustomer($event, false)"
                                                   [placeholder]="
                                                    isLoaded(customers)
                                                        ? isCustomerSearchFocused
                                                            ? 'Please, start typing to find a customer'
                                                            : 'Search...'
                                                        : 'Loading ...'
                                                "
                                                   name="customer" />

                                            <button *ngIf="
                                                    (!isEditMode || updatingPendingOperation) &&
                                                    canChangeCustomer && selectedCustomer
                                                "
                                                    id="clearSelectedCustomer"
                                                    type="button"
                                                    class="btn btn-light btn-outline-secondary"
                                                    (click)="clearSelectedCustomer()">
                                                <i class="fa fa-multiply" aria-hidden="true"></i>
                                            </button>
                                            
                                        </div>
                                    </td>
                                </tr>
                                <tr class="form-field">
                                    <td class="col-label job">
                                        Project No.
                                        <ng-template #loadingJobs>
                                            <span>
                                                <i class="icon fa-solid fa-arrows-rotate loading"></i>
                                            </span>
                                        </ng-template>
                                        <span *ngIf="isLoaded(filteredJobs) || jobsFetched; else loadingJobs"
                                              class="required">
                                            *
                                        </span>
                                        <span *ngIf="selectedJob?.externalId"
                                              class="job_number small_text">
                                            {{'#' + selectedJob?.externalId }}
                                        </span>
                                    </td>
                                    <td class="col-value">
                                        <div class="input-group">
                                            <input *ngIf="
                                                    (!isEditMode || updatingPendingOperation)
                                                    && (
                                                        !filteredJobs.length
                                                        || isNewJobRequested
                                                    )
                                                "
                                                   class="form-control"
                                                   type="text"
                                                   id="job_name"
                                                   formControlName="job_name"
                                                   maxlength="55"
                                                   [placeholder]="
                                                    isNewJobRequested
                                                        ? 'Enter job name (55 chars max.)'
                                                        : !selectedCustomer?.id
                                                            ? 'Please select a customer first'
                                                            : 'Loading ...'
                                                " />
                                            <ng-container *ngIf="!isNewJobRequested">
                                                <input *ngIf="
                                                        (isEditMode && !updatingPendingOperation) ||
                                                        filteredJobs.length
                                                    "
                                                       class="form-control"
                                                       [class]="{
                                                        disabledEl: isEditMode && !updatingPendingOperation
                                                    }"
                                                       type="text"
                                                       id="job"
                                                       formControlName="job"
                                                       [placeholder]="
                                                        jobsFetched &&
                                                        filteredJobs.length
                                                            ? 'Search or select job'
                                                            : 'Loading ...'
                                                    "
                                                       [ngbTypeahead]="searchJob"
                                                       #jobTypeahead="ngbTypeahead"
                                                       (keydown)="arrowKeyCheck($event, jobTypeahead)"
                                                       [resultFormatter]="
                                                        jobAheadFormatter
                                                    "
                                                       [inputFormatter]="
                                                        jobValueFormatter
                                                    "
                                                       [editable]="false"
                                                       container=".modal-open .modal"
                                                       #jobSearch
                                                       (focus)="$event.target.select()"
                                                       (selectItem)="
                                                        onJobSelect($event)
                                                    " />
                                                <select *ngIf="
                                                        (!isEditMode || updatingPendingOperation) &&
                                                        filteredJobs.length
                                                    "
                                                        class="form-select CP"
                                                        id="job_selector"
                                                        (change)="
                                                        jobSelectedFromDropDown(
                                                            $event
                                                        )
                                                    "
                                                        (click)="checkFocusState($event)"
                                                        (focus)="checkFocusState($event)"
                                                        (blur)="checkFocusState($event)"
                                                        [disabled]="isEditMode && !updatingPendingOperation">
                                                    <option value="0"
                                                            disabled
                                                            selected="selected">
                                                        Select ...
                                                    </option>
                                                    <option *ngFor="
                                                            let job of filteredJobs
                                                        "
                                                            [value]="job.id">
                                                        {{
                                                            job.nonUniqName
                                                                ? job.name +
                                                                " (" +
                                                                (job.externalId
                                                                    ? job.externalId
                                                                    : " - - ") +
                                                                ")"
                                                                : job.name.length > 55 ? job.name.slice(0, 55) + '...' : job.name
                                                        }}
                                                    </option>
                                                </select>
                                            </ng-container>
                                            <button *ngIf="
                                                    (!isEditMode || updatingPendingOperation)
                                                    && filteredJobs.length && canCreateJob
                                                "
                                                    id="new_job_switcher"
                                                    type="button"
                                                    class="btn"
                                                    [ngClass]="
                                                    isNewJobRequested
                                                        ? 'btn-danger'
                                                        : 'btn-success'
                                                "
                                                    (click)="toggleNewJobRequested()">
                                                <i class="fa"
                                                   [ngClass]="
                                                        isNewJobRequested
                                                            ? 'fa-multiply'
                                                            : 'fa-plus'
                                                    "
                                                   aria-hidden="true"></i>
                                            </button>
                                            <button *ngIf="
                                                    (!isEditMode || updatingPendingOperation)
                                                    && !searchByJobNumber
                                                    && !isNewJobRequested
                                                    && !filteredJobs.length
                                                "
                                                    id="search_by_job_number"
                                                    type="button"
                                                    class="btn btn-primary"
                                                    (click)="activateSearchByJobNumber()">
                                                <i class="fa fa-search" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="form-field">
                                    <td class="col-label task">
                                        Task
                                        <ng-template #loadingTasks>
                                            <span>
                                                <i class="icon fa-solid fa-arrows-rotate loading"></i>
                                            </span>
                                        </ng-template>
                                        <span *ngIf="isLoaded(filteredTasks) || tasksFetched; else loadingTasks"
                                              class="required">
                                            *
                                        </span>
                                        <span *ngIf="selectedTask?.externalId"
                                              class="task_number small_text">
                                            {{'#' + selectedTask?.externalId }}
                                        </span>
                                    </td>
                                    <td class="col-value">
                                        <div class="input-group">
                                            <input *ngIf="
                                                    (!isEditMode || updatingPendingOperation)
                                                    && (
                                                        !filteredTasks.length
                                                        || isNewTaskRequested
                                                    )
                                                "
                                                   class="form-control"
                                                   type="text"
                                                   id="task_name"
                                                   formControlName="task_name"
                                                   maxlength="255"
                                                   [placeholder]="
                                                    isNewTaskRequested
                                                        ? 'Enter task name (55 chars max.)'
                                                        : !selectedJob?.id
                                                            ? 'Please select the job first'
                                                            : 'Loading ...'
                                                " />
                                            <ng-container *ngIf="!isNewTaskRequested">
                                                <input *ngIf="
                                                        (isEditMode && !updatingPendingOperation) ||
                                                        filteredTasks.length
                                                    "
                                                       class="form-control"
                                                       [class]="{
                                                        disabledEl: isEditMode && !updatingPendingOperation
                                                    }"
                                                       type="text"
                                                       id="task"
                                                       formControlName="task"
                                                       [placeholder]="
                                                        tasksFetched &&
                                                        filteredTasks.length
                                                            ? 'Search or select task'
                                                            : 'Loading ...'
                                                    "
                                                       [ngbTypeahead]="searchTask"
                                                       #taskTypeahead="ngbTypeahead"
                                                       (keydown)="arrowKeyCheck($event, taskTypeahead)"
                                                       [resultFormatter]="
                                                        taskAheadFormatter
                                                    "
                                                       [inputFormatter]="
                                                        taskValueFormatter
                                                    "
                                                       [editable]="false"
                                                       container=".modal-open .modal"
                                                       #taskSearch
                                                       (focus)="$event.target.select()"
                                                       (selectItem)="
                                                        onTaskSelect($event)
                                                    " />
                                                <select *ngIf="
                                                        (!isEditMode || updatingPendingOperation) &&
                                                        filteredTasks.length
                                                    "
                                                        class="form-select CP"
                                                        id="task_selector"
                                                        (change)="
                                                        taskSelectedFromDropDown(
                                                            $event
                                                        )
                                                    "
                                                        (click)="checkFocusState($event)"
                                                        (focus)="checkFocusState($event)"
                                                        (blur)="checkFocusState($event)"
                                                        [disabled]="isEditMode && !updatingPendingOperation">
                                                    <option value="0"
                                                            disabled
                                                            selected="selected">
                                                        Select ...
                                                    </option>
                                                    <option *ngFor="
                                                            let task of filteredTasks
                                                        "
                                                            [value]="task.id">
                                                        {{
                                                            task.nonUniqName
                                                                ? task.name +
                                                                " (" +
                                                                (task.externalId
                                                                    ? task.externalId
                                                                    : " - - ") +
                                                                ")"
                                                                : task.name.length > 55 ? task.name.slice(0, 55) + '...' : task.name
                                                        }}
                                                    </option>
                                                </select>
                                            </ng-container>
                                            <button *ngIf="
                                                    (!isEditMode || updatingPendingOperation)
                                                    && !isNewJobRequested
                                                    && filteredTasks.length
                                                    && canCreateTask
                                                "
                                                    id="new_task_switcher"
                                                    type="button"
                                                    class="btn"
                                                    [ngClass]="
                                                    isNewTaskRequested
                                                        ? 'btn-danger'
                                                        : 'btn-success'
                                                "
                                                    (click)="toggleNewTaskRequested()">
                                                <i class="fa"
                                                   [ngClass]="
                                                        isNewTaskRequested
                                                            ? 'fa-multiply'
                                                            : 'fa-plus'
                                                    "
                                                   aria-hidden="true"></i>
                                            </button>
                                            </div>
                                            </tr>
                                <ng-container *ngIf="(!isEditMode || updatingPendingOperation) && isNewTaskRequested">
                                    <tr class="form-field">
                                        <td class="col-label">
                                            Number series
                                            <span class="required">
                                                *
                                            </span>
                                        </td>
                                        <td class="col-value">
                                            <input class="form-control"
                                                   type="number"
                                                   formControlName="taskNumberSeries"
                                                   min="0"
                                                   step="1" />
                                        </td>
                                    </tr>
                                    <tr class="form-field">
                                        <td class="col-label">
                                            Department
                                            <span class="required">
                                                *
                                            </span>
                                        </td>
                                        <td class="col-value">
                                            <select class="form-select"
                                                    formControlName="taskDepartmentCode">
                                                <option value="null" disabled>
                                                    Select department
                                                </option>
                                                <option *ngFor="let department of departmentCodes"
                                                        [ngValue]="department.value">
                                                    {{ department.label }}
                                                </option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr class="form-field">
                                        <td class="col-label">
                                            Assignment date
                                            <span class="required">
                                                *
                                            </span>
                                        </td>
                                        <td class="col-value">
                                            <app-tba-date-time [date]="operationForm.get('taskAssignmentDate')?.value"
                                                               [minDate]="minDate"
                                                               (dateChange)="operationForm.get('taskAssignmentDate')?.setValue($event)">
                                            </app-tba-date-time>
                                        </td>
                                    </tr>
                                    <tr class="form-field">
                                        <td class="col-label">
                                            Reference
                                        </td>
                                        <td class="col-value">
                                            <input class="form-control"
                                                   type="text"
                                                   formControlName="taskReference"
                                                   maxlength="255"
                                                   placeholder="Optional (255 chars max)" />
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr class="form-field">
                                    <td class="col-label startDateTime">
                                        Start Date
                                        <span class="required">*</span>
                                    </td>
                                    <td class="col-value">
                                        <div class="startDateTime-input">
                                            <app-tba-date-time
                                                [(date)]="
                                                    operationForm.controls[
                                                        'startDateTime'
                                                    ].value
                                                "
                                                id="startDateTime"
                                                [minDate]="minDate"
                                                (dateChange)="restartDateTime('startDateTime')"
                                            ></app-tba-date-time>
                                        </div>
                                    </td>
                                </tr>

                                <tr class="form-field" *ngIf="isLongTermOperation; else estimatedTime">
                                    <td class="col-label endDateTime">
                                        End Date
                                        <span class="required">*</span>
                                    </td>
                                    <td class="col-value">
                                        <div class="endDateTime-input">
                                            <app-tba-date-time
                                                [(date)]="
                                                    operationForm.controls[
                                                        'endDateTime'
                                                    ].value
                                                "
                                                id="endDateTime"
                                                [minDate]="minDate"
                                                (dateChange)="restartDateTime('endDateTime')"
                                            ></app-tba-date-time>
                                        </div>
                                    </td>
                                </tr>

                                <ng-template #estimatedTime>
                                <tr class="form-field">
                                    <td class="col-label estimatedTime">
                                        Estimated time
                                        <span class="required">*</span>
                                    </td>
                                    <td class="col-value">
                                        <div class="time-container flex">
                                            <select
                                                class="form-select col-2"
                                                formControlName="estimatedTimeHours"
                                                (change)="onEstimatedTimeHoursChange()"
                                            >
                                                <option value="" disabled>
                                                    Hours
                                                </option>
                                                <option
                                                    *ngFor="
                                                        let hour of [].constructor(
                                                            24
                                                        );
                                                        let i = index
                                                    "
                                                    [value]="i"
                                                >
                                                    {{ i }}
                                                </option>
                                            </select>
                                            <select
                                                class="form-select col-2"
                                                formControlName="estimatedTimeMinutes"
                                                (change)="onEstimatedTimeMinutesChange()"
                                            >
                                                <option value="" disabled>
                                                    Minutes
                                                </option>
                                                <option
                                                    *ngFor="
                                                        let minute of periodsInMinutes;
                                                        let i = index
                                                    "
                                                    [value]="minute"
                                                >
                                                    {{ minute }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="checkbox_field CP small_text" (click) = "toggleLongTermOperation()">
                                            <input type="checkbox" class="VM m-2"> select End Date from calendar
                                        </div>
                                    </td>
                                </tr>
                                </ng-template>
                                <tr class="form-field">
                                    <td class="col-label location">
                                        Location
                                        <ng-template #loadingLocations>
                                            <span>
                                                <i class="icon fa-solid fa-arrows-rotate loading"></i>
                                            </span>
                                        </ng-template>
                                        <span *ngIf="isLoaded(locations); else loadingLocations"
                                            class="required"
                                        >
                                            *
                                        </span>
                                    </td>
                                    <td class="col-value">
                                        <select
                                            class="form-select CP"
                                            id="location_selector"
                                            formControlName="location"
                                            #locationSelector
                                            (change)="onLocationChange()"
                                        >
                                            <option
                                                value="0"
                                                disabled
                                                selected="selected"
                                            >
                                                Select Location ...
                                            </option>
                                            <option
                                                *ngFor="let location of locations"
                                                [value]="location.id"
                                            >
                                                {{ location.name }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>

                                <tr class="form-field">
                                    <td class="col-label notes">
                                        Notes
                                        <span *ngIf="locationSelector?.selectedIndex === (locationSelector?.options.length - 1)"
                                            class="required"
                                        >
                                            *
                                        </span>
                                    </td>
                                    <td class="col-value">
                                        <input
                                            class="form-control"
                                            type="text"
                                            id="notes"
                                            formControlName="notes"
                                            [placeholder]="locationSelector?.value !== '0' && locationSelector?.selectedIndex === (locationSelector?.options.length - 1)
                                                ? 'Please describe your location here'
                                                : 'Optional (255 chars max.)'"
                                            size="25"
                                            maxlength="255"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!-- Operation details section -->
                        <div class="operation-details col-2">
                            <div class="main-content-header">
                                <h5>Operation details</h5>
                            </div>
                            <table>
                                <tr class="form-field">
                                    <td class="col-label description">
                                        Description
                                        <span class="required">*</span>
                                    </td>
                                    <td class="col-value">
                                        <textarea
                                            class="form-control"
                                            id="description"
                                            formControlName="description"
                                            rows="12"
                                            placeholder="Put operation description here (2000 chars maximum)"
                                            maxlength="2000"
                                        ></textarea>
                                    </td>
                                </tr>

                                <tr class="form-field">
                                    <td class="col-label important">Important notes</td>
                                    <td class="col-value">
                                        <input
                                            class="form-control"
                                            type="text"
                                            id="important"
                                            formControlName="important"
                                            placeholder="Optional (55 chars max.)"
                                            size="25"
                                            maxlength="55"
                                        />
                                    </td>
                                </tr>

                                <tr class="form-field">
                                    <td class="col-label responsible">
                                        Responsible
                                        <ng-template #loadingResponsible>
                                            <span>
                                                <i class="icon fa-solid fa-arrows-rotate loading"></i>
                                            </span>
                                        </ng-template>
                                        <span *ngIf="isLoaded(fetchedWorkers); else loadingResponsible"
                                            class="required"
                                        >
                                            *
                                        </span>
                                    </td>
                                    <td class="col-value">
                                        <div class="input-group">
                                            <input
                                                class="form-control"
                                                type="text"
                                                id="responsible"
                                                formControlName="responsible"
                                                [placeholder]="
                                                    responsible.workers.length
                                                        ? 'Search or select person'
                                                        : 'Loading ...'
                                                "
                                                [ngbTypeahead]="searchWorker"
                                                #responsibleTypeahead="ngbTypeahead"
                                                (keydown)="arrowKeyCheck($event, responsibleTypeahead)"
                                                [resultFormatter]="
                                                    workerValueFormatter
                                                "
                                                [inputFormatter]="
                                                    workerValueFormatter
                                                "
                                                [editable]="false"
                                                container=".modal-open .modal"
                                                #responsiblePersonSearch
                                                (selectItem)="
                                                    onWorkerSelect($event)
                                                "
                                                (focus) = "currentWorkersList = responsible"
                                                (blur) = "currentWorkersList = undefined"
                                            />
                                            <select
                                                class="form-select"
                                                id="responsible_selector"
                                                placeholder="Select responsible person"
                                                (change)="
                                                    workerSelectedFromDropDown(
                                                        $event, responsible
                                                    )
                                                "
                                                (click)="checkFocusState($event)"
                                                (focus)="checkFocusState($event)"
                                                (blur)="checkFocusState($event)"
                                            >
                                                <option value="0" disabled selected="selected">
                                                    Select responsible person
                                                </option>
                                                <option
                                                    *ngFor="
                                                        let person of responsible.workers
                                                    "
                                                    [value]="person.id"
                                                >
                                                    {{
                                                        person.nonUniqName
                                                            ? person.name +
                                                            " (" +
                                                            (person.personNumber
                                                                ? person.personNumber
                                                                : " - - ") +
                                                            ")"
                                                            : person.name
                                                    }}
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <ng-container
                                    *ngIf="!isRequestMode && !updatingPendingOperation"
                                >
                                <tr
                                    *ngFor="let person of involvedPersons; first as isFirst"
                                >
                                    <td class="col-label"><div *ngIf="isFirst">Involved</div></td>
                                    <td class="col-value readonly">
                                        <div class="flex TC">
                                            {{
                                                person.nonUniqName
                                                    ? person.name +
                                                        " (" +
                                                        (person.personNumber
                                                            ? person.personNumber
                                                            : " - - ") +
                                                        ")"
                                                    : person.name
                                            }}
                                            <div style="flex-grow: 1"></div>
                                            <button
                                                type="button"
                                                style="align-self: flex-start"
                                                class="btn btn-sm btn-outline-danger"
                                                (click)="removeInvolved(person)"
                                            >
                                                <fa-icon [icon]="faDelete"></fa-icon>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="form-field">
                                    <td class="col-label available">
                                        <div *ngIf="!isLoaded(involvedPersons)">
                                            Involved
                                            <ng-template #loadingInvolvedPersons>
                                                <span>
                                                    <i class="icon fa-solid fa-arrows-rotate loading"></i>
                                                </span>
                                            </ng-template>
                                            <span *ngIf="isLoaded(fetchedWorkers); else loadingInvolvedPersons"
                                                class="required"
                                            >
                                                *
                                            </span>
                                        </div>
                                    </td>
                                    <td class="col-value">
                                        <div class="input-group">
                                            <input
                                                class="form-control"
                                                type="text"
                                                id="available"
                                                formControlName="available"
                                                [placeholder]="
                                                    available.workers.length
                                                        ? 'Search or select person'
                                                        : 'Loading ...'
                                                "
                                                [ngbTypeahead]="searchWorker"
                                                #availableTypeahead="ngbTypeahead"
                                                (keydown)="arrowKeyCheck($event, availableTypeahead)"
                                                [resultFormatter]="
                                                    workerValueFormatter
                                                "
                                                [inputFormatter]="
                                                    workerValueFormatter
                                                "
                                                [editable]="false"
                                                container=".modal-open .modal"
                                                #availablePersonSearch
                                                (selectItem)="
                                                    onWorkerSelect($event)
                                                "
                                                (focus) = "currentWorkersList = available"
                                                (blur) = "currentWorkersList = undefined"
                                            />
                                            <select
                                                class="form-select"
                                                id="available_selector"
                                                placeholder="Select involved person"
                                                (change)="
                                                    workerSelectedFromDropDown(
                                                        $event, available
                                                    )
                                                "
                                                (click)="checkFocusState($event)"
                                                (focus)="checkFocusState($event)"
                                                (blur)="checkFocusState($event)"
                                            >
                                                <option value="0" disabled selected="selected">
                                                    Select involved person
                                                </option>
                                                <option
                                                    *ngFor="
                                                        let operator of available.workers
                                                    "
                                                    [value]="operator.id"
                                                >
                                                    {{
                                                        operator.nonUniqName
                                                            ? operator.name +
                                                            " (" +
                                                            (operator.personNumber
                                                                ? operator.personNumber
                                                                : " - - ") +
                                                            ")"
                                                            : operator.name
                                                    }}
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                </ng-container>
                            </table>
                        </div>
                    </div>
                </form>
            </app-info-group-body>
        </div>
    </div>

        <div class="modal-footer">
            <button *ngIf="operation?.id"
                    class="btn btn-outline-dark btn-sm comment-button"
                    (click)="toggleLogbook()">

                <i class="fa-solid fa-comments"></i>
                <span *ngIf="operation.hasComments"
                      class="notification-dot"
                      [class.unread-dot]="operation?.hasUnreadComments"
                      [class.read-dot]="!operation?.hasUnreadComments && operation?.hasComments">
                </span>
            </button>
        <div class="btn-group actions">
            <button *ngIf="!(isEditMode || isAcceptMode)"
                    class="btn btn-primary"
                    ngbAutofocus
                    (click)="CreateOperation()">
                {{ workingMode | titlecase }} {{ (isCopyMode ? "the" : "an") }} operation
            </button>
            <button *ngIf="isEditMode || isAcceptMode"
                    class="btn btn-primary"
                    ngbAutofocus
                    (click)="UpdateOperation()">
                {{ (isAcceptMode ? workingMode : "Update") | titlecase }} the operation
            </button>
        </div>
    </div>
    <i *ngIf="isLoadingState" class="icon fa-solid fa-arrows-rotate loading state"></i>
</div>

<app-operation-logbook *ngIf="showLogbook && operation?.id"
                       class="floating-logbook"
                       [operationId]="operation.id"
                       [embedded]="true"
                       (closed)="showLogbook = false">
</app-operation-logbook>
